import React from "react";

class LOLout extends React.Component {
    render() {
      const styles={
        blackbg: {
          backgroundColor: "#121212"
        },
        blueText:{
          color: "#037ef3"
        }
      }

      return <div className="w-full h-full text-white" style={styles.blackbg}>
            <div className="w-full max-w-2xl m-auto py-8 px-4">
                <div className="text-xl" style={styles.blueText}>AIESEC in SLIIT</div>
                <div className="text-4xl font-bold">LOLout - Stand-up Comedy Event</div>
                <div className="text-xl mt-1 text-gray-400">Application Package</div>

                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-1 font-semibold">Functional Introduction</div>
                  <p className="text-gray-400">An event organized by AIESEC in SLIIT, bringing in stand-up comedians from Sri Lanka and around the world as well. This event will be happening on one weekend day of August. 
                  </p>
                </div>

                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-1 font-semibold">Timeline</div>
                  <div>
                    <span className="font-bold">Application Open - </span> <span className="text-gray-300">21st June</span> <br/>
                    <span className="font-bold">Application Deadline - </span> <span className="text-gray-300">27th June</span> <br/>
                  </div>
                </div>

                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-1 font-semibold">Team Structure</div>
                  <div>
                    <span className="font-bold">OCVP Delegates</span> <span className="text-gray-400">x1</span> <br/>
                    <span className="font-bold">OCVP Marketing</span> <span className="text-gray-400">x1</span> <br/>
                    <span className="font-bold">OCVP External Relations</span> <span className="text-gray-400">x2</span> <br/>
                    <span className="font-bold">OCVP Logistics</span> <span className="text-gray-400">x1</span> <br/>
                    <span className="font-bold">OCVP Finance</span> <span className="text-gray-400">x1</span> <br/>
                    <span className="font-bold">OCVP Events</span> <span className="text-gray-400">x2</span> <br/>
                  </div>
                </div>

                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-1 font-semibold">Available Roles</div>
                  <br/>

                  
                  {/*  =====================================================  */}
                  <div className="w-full rounded-lg border p-2" style={{"border": "2px solid #0373f3" }}>
                    <div className="text-center text-2xl font-bold" style={{"color": "#0373f3" }}>OCVP Delegates <span className="text-gray-500"> x1</span></div>

                    <div className="font-bold">Job Description</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Being the first touchpoint between LOLout delegates and AIESEC in SLIIT</li>
                        <li>Setting up expectation setting and internal briefing about the requirements</li>
                        <li>Answering all the inquiries from the participants</li>
                        <li>Creating and managing a database of the participants</li>
                        <li>Managing invitations of participants</li>
                        <li>Managing the registrations of the participants</li>
                      </ul>
                    </div> <br/>

                    <div className="font-bold">Experience</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Experience in Coordinating and negotiating with people</li>
                        <li>Experience in event management and coordination</li>
                      </ul>
                    </div>
                  </div>
                  <br />

                  {/*  =====================================================  */}
                  <div className="w-full rounded-lg border p-2" style={{"border": "2px solid #F85A40" }}>
                    <div className="text-center text-2xl font-bold" style={{"color": "#F85A40" }}>OCVP Marketing <span className="text-gray-500"> x1</span></div>

                    <div className="font-bold">Job Description</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Approach electronic media for Pre-promotions</li>
                        <li>Coordinate interviews with the media</li>
                        <li>Work with ER team for sales</li>
                        <li>Design and launch promotional materials to attract participants</li>
                      </ul>
                    </div> <br/>

                    <div className="font-bold">Experience</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Experience in partnership management with variety of Stakeholders</li>
                        <li>Experience in planning and running marketing campaigns</li>
                        <li>Experience on designing promotional material for an event</li>
                      </ul>
                    </div>
                  </div> <br/>

                  {/*  =====================================================  */}
                  <div className="w-full rounded-lg border p-2" style={{"border": "2px solid #FFC845" }}>
                    <div className="text-center text-2xl font-bold" style={{"color": "#FFC845" }}>OCVP External Relations <span className="text-gray-500"> x2</span></div>

                    <div className="font-bold">Job Description</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Conduct market researches on potential partners together with OEVP PD</li>
                        <li>Approach potential companies for sponsorships </li>
                        <li>Follow-ups and sponsorship delivery</li>
                        
                      </ul>
                    </div> <br/>

                    <div className="font-bold">Experience</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Market research experience of partnership management with a variety of stakeholders</li>
                        <li>Experience on event management and sales</li>
                        <li>Experience in planning and running PR and marketing campaigns for events</li>
                      </ul>
                    </div>
                  </div> <br/>

                   {/*  =====================================================  */}
                   <div className="w-full rounded-lg border p-2" style={{"border": "2px solid #0CB9C1" }}>
                    <div className="text-center text-2xl font-bold" style={{"color": "#0CB9C1" }}>OCVP Finance<span className="text-gray-500"> x1</span></div>

                    <div className="font-bold">Job Description</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Preparing event budget</li>
                        <li>Collecting and documentation of all the supporting documents</li>
                        <li>Preparing the event report</li>
                        <li>Expenses an partnership tracking</li>
                        <li>Ensure partnership delivery</li>                        
                      </ul>
                    </div> <br/>

                    <div className="font-bold">Experience</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Experience in budget preparation</li>
                        <li>Experience in budgetary control</li>
                      </ul>
                    </div>
                  </div> <br/>

                  {/*  =====================================================  */}
                  <div className="w-full rounded-lg border p-2" style={{"border": "2px solid #0373f3" }}>
                    <div className="text-center text-2xl font-bold" style={{"color": "#0373f3" }}>OCVP Events<span className="text-gray-500"> x2</span></div>

                    <div className="font-bold">Job Description</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Delivering the model of the event</li>
                        <li>Managing guests invitation</li>
                        <li>Ensuring all systems are in place for guests</li>
                        <li>Securing guest speakers and ensuring their objectives are achieved</li>
                        <li>Managing the experience of the guests</li>
                        <li>Responsible for the smooth flow of the event</li>                        
                      </ul>
                    </div> <br/>

                    <div className="font-bold">Experience</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Experience in event planning and management</li>
                        <li>Experience in attention to detail and working under pressure</li>
                        <li>Professional communication skills</li>
                      </ul>
                    </div>
                  </div>


                {/** Contact Info ***/}
                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-4 font-semibold">Contact Info</div>
                  <div>
                    <div >For any clarifications, </div> 
                    <div style={styles.blueText} className="text-3xl">Chamoda De Silva</div> 
                    <div className="text-gray-400">OEVP iGT IR – AIESEC in SLIIT</div>
                    <div className="text-gray-400">chamoda.desilva@aiesec.net</div>
                    <div className="text-gray-400">+94 76 347 5709</div>
                    
                  </div>
                </div>

                

                <a href="https://docs.google.com/forms/d/e/1FAIpQLSc-b3bIOAm-jWWeXG0Fb-o7N8zti2UPW6fWQ5ltgh8wy7pWBA/viewform?usp=sf_link" target="_blank" rel="noreferrer">
                <div className="my-8 rounded-md w-full h-10 text-center text-lg font-bold grid content-center cursor-pointer" style={{"background": "#037ef3"}}>
                  Apply
                </div>
                </a>

                </div>
            </div>
      </div>;
    }
  }

export default LOLout